import { Pipe, PipeTransform } from '@angular/core';
import { isNullOrEmpty, searchAndWrapPhrase } from '@maximizer/shared/util';

@Pipe({ name: 'highlightText', })
export class HighlightTextPipe implements PipeTransform {
  transform(
    value: string,
    searchPhrase?: string,
    spanClass = 'font-bold',
    allOccurrences = false,
  ): string {
    if (value && searchPhrase && !isNullOrEmpty(searchPhrase)) {
      return searchAndWrapPhrase(value, searchPhrase, spanClass, allOccurrences);
    }
    return value;
  }
}
